import React, { Component } from "react";
import PropTypes from "prop-types";

class DownloadButton extends Component {
    render() {
        const { url, size } = this.props;

        return (
            <a href={url} className="download-button download-button--blue">
                <div className="download-button__inner">
                    <b>Download ZIP</b> -{" "}
                    <span className="download-button__size">{size}</span>
                </div>
                <div className="download-button__icon" />
            </a>
        );
    }
}

DownloadButton.propTypes = {
    url: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired
};

export default DownloadButton;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/DownloadButton.js